/**
 * 适配器层的传输错误类型（与 HTTP 状态码错误 `ApiError` 区分开）：
 * 这类错误意味着**没拿到任何服务端响应**，调用方据此决定是否重试、是否进离线队列。
 */

/**
 * 请求超时。
 * 单独建模的原因：超时后客户端无法判断服务端是否已受理，
 * 与"用户主动取消"（AbortError）必须区分开 —— 前者可重试/可入队，后者应直接放弃。
 */
export class RequestTimeoutError extends Error {
  constructor(readonly timeoutMs: number) {
    super(`请求超时（${timeoutMs}ms）`);
    this.name = 'RequestTimeoutError';
  }
}

/** 是否为超时错误（跨适配器统一判断，避免各处自己 `name === 'RequestTimeoutError'`）。 */
export function isTimeoutError(error: unknown): error is RequestTimeoutError {
  return error instanceof RequestTimeoutError || (error as { name?: string } | null)?.name === 'RequestTimeoutError';
}
